var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("img", {
        staticClass: "topimg",
        attrs: { src: require("../assets/newimg/images/logo_03_03.png") }
      }),
      _vm._v(" "),
      _c(
        "form",
        [
          _c("div", { staticClass: "input-control" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.iccid,
                  expression: "iccid"
                }
              ],
              attrs: { placeholder: "输入设备号" },
              domProps: { value: _vm.iccid },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.iccid = $event.target.value
                }
              }
            }),
            _vm._v(" "),
            _vm.wxReady
              ? _c("img", {
                  staticClass: "addon",
                  attrs: { src: require("../assets/images/scan.png") },
                  on: { click: _vm.handleScan }
                })
              : _vm._e()
          ]),
          _vm._v(" "),
          _vm.cardCheckOK == true && _vm.needAuth == 1 && _vm.binded == false
            ? [
                _c("div", { staticClass: "input-control" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.ruleForm.name,
                        expression: "ruleForm.name"
                      }
                    ],
                    attrs: { placeholder: "使用人姓名" },
                    domProps: { value: _vm.ruleForm.name },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.ruleForm, "name", $event.target.value)
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "input-control" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.ruleForm.mobile,
                        expression: "ruleForm.mobile"
                      }
                    ],
                    attrs: { placeholder: "输入手机号" },
                    domProps: { value: _vm.ruleForm.mobile },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.ruleForm, "mobile", $event.target.value)
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "span",
                    { staticClass: "smscode", on: { click: _vm.handleSms } },
                    [_vm._v(_vm._s(_vm.smsBtnTxt))]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "input-control" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.ruleForm.code,
                        expression: "ruleForm.code"
                      }
                    ],
                    attrs: { placeholder: "输入验证码" },
                    domProps: { value: _vm.ruleForm.code },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.ruleForm, "code", $event.target.value)
                      }
                    }
                  })
                ])
              ]
            : _vm.binded == true && _vm.needAuth == 1
            ? [
                _c("div", { staticClass: "input-control" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.bindInfo.username,
                        expression: "bindInfo.username"
                      }
                    ],
                    attrs: { disabled: "", placeholder: "使用人姓名" },
                    domProps: { value: _vm.bindInfo.username },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.bindInfo, "username", $event.target.value)
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "input-control" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.bindInfo.mobile,
                        expression: "bindInfo.mobile"
                      }
                    ],
                    attrs: { disabled: "", placeholder: "输入手机号" },
                    domProps: { value: _vm.bindInfo.mobile },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.bindInfo, "mobile", $event.target.value)
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticStyle: { "font-size": ".24rem", color: "#000" } },
                  [
                    _vm._v(
                      "以上信息为此号码当前绑定的使用人信息，如有疑问，请联系客服"
                    )
                  ]
                )
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.cardCheckOK == false
            ? _c(
                "div",
                { staticClass: "btn", on: { click: _vm.handleCheckCard } },
                [_vm._v("查询")]
              )
            : _vm.binded == false
            ? _c(
                "div",
                { staticClass: "btn", on: { click: _vm.handleBindCard } },
                [_vm._v("绑定")]
              )
            : _vm.binded == true
            ? _c(
                "div",
                { staticClass: "btn", on: { click: _vm.handleQueryCard } },
                [_vm._v("确认")]
              )
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c(
        "van-dialog",
        {
          attrs: { showConfirmButton: false },
          model: {
            value: _vm.xieyimodal,
            callback: function($$v) {
              _vm.xieyimodal = $$v
            },
            expression: "xieyimodal"
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "xieyibox",
              style: { maxHeight: _vm.dialogHeight, overflowY: "scroll" }
            },
            [
              _c("div", { staticClass: "xy-title" }, [_vm._v("特别提醒")]),
              _vm._v(" "),
              _c("div", { staticClass: "xy-content" }, [
                _c("div", [
                  _vm._v(
                    "您正在办理平台“物联网卡实名认证”业务,如果您点击页末“同意”按钮，您即将进入实名认证页面并向我司提供如下个人信息，所有产品和服务统一适用的一般性隐私条款，如我们的具体产品和服务单独的隐私政策与本政策有不一致的，以具体产品和服务单独的隐私政策为准。"
                  )
                ]),
                _vm._v(" "),
                _c("div", [_vm._v("1、本人的身份证信息")]),
                _vm._v(" "),
                _c("div", [_vm._v("2、本人实名制联系电话")]),
                _vm._v(" "),
                _c("div", [
                  _vm._v(
                    "本公司保证仅为向您提供物联网卡服务而收集:使用、存储您的个人信息。当您不再使用本公司物联网卡服务，我司将在法定期限内删除您的个人信息"
                  )
                ]),
                _vm._v(" "),
                _c("div", [
                  _vm._v(
                    "1、为您提供物联网卡的开通、使用、日常维护售后咨询服务"
                  )
                ]),
                _vm._v(" "),
                _c("div", [_vm._v("2、向您提供物联网卡相关的优惠政策推送")])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "btn" }, [
                _c("div", { on: { click: _vm.confirmxieyi } }, [
                  _vm._v("同意")
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    on: {
                      click: function($event) {
                        _vm.xieyimodal = false
                      }
                    }
                  },
                  [_vm._v("取消")]
                )
              ])
            ]
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "tips" }, [
      _c("div", { staticClass: "title" }, [_vm._v("温馨提示：")]),
      _vm._v(" "),
      _c("div", [_vm._v("1：卡号为卡芯后的数字，短号为设备背面的字母和数字")]),
      _vm._v(" "),
      _c("div", [_vm._v("2：因产品实名使用之后，无法二次销售，故无法退卡")]),
      _vm._v(" "),
      _c("div", [_vm._v("3：绑卡时请核实该地区是否能使用，谨慎操作")]),
      _vm._v(" "),
      _c("div", [_vm._v("4：新疆、西藏、云南、港澳台不可使用!")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a89e4f7e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ../app/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a89e4f7e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!../app/node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/bind.vue
// module id = null
// module chunks = 